// src/components/app/RouteError.jsx
// Error page for React Router errorElement
import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';

export default function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Log route error
    console.error('[RouteError] Route error caught:', {
      message: error?.message || error?.statusText,
      status: error?.status,
      stack: error?.stack,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b12] text-white p-6">
      <div className="max-w-lg w-full bg-[#14141c] border border-white/10 rounded-2xl p-8 text-center">
        <div className="text-6xl mb-4">⚠️</div>
        <h1 className="text-2xl font-bold mb-3">Page Error</h1>
        <p className="text-white/70 mb-2">
          {error?.status === 404
            ? 'This page could not be found.'
            : 'There was a problem loading this page.'}
        </p>
        {error?.message && (
          <p className="text-sm text-white/50 mb-6 font-mono">
            {error.message}
          </p>
        )}

        <div className="flex gap-3 justify-center">
          <button
            onClick={handleReload}
            className="px-5 py-2.5 rounded-lg bg-fuchsia-600 hover:bg-fuchsia-700 font-semibold transition-colors"
          >
            🔄 Reload
          </button>
          <button
            onClick={handleGoHome}
            className="px-5 py-2.5 rounded-lg bg-white/10 hover:bg-white/20 font-semibold transition-colors"
          >
            🏠 Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
